import React, { useEffect, useState } from 'react';

import './App.css';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Theme';
import Sidebar from './Sidebar';
import Header from './Header';
import DashboardPage from './modules/dashboard/DashboardPage';
import MessagesPage from './modules/messages/MessagesPage';
import AudiencePage from './modules/audience/AudiencePage';
import CreateMessagePage from './modules/messages/create/CreateMessagePage';
import { ToastContainer } from 'react-toastify';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import LoginPage from './modules/login/LoginPage';
import AcceptInvitationPage from './modules/login/AcceptInvitationPage';
import UsersPage from './modules/admin/users/UsersPage';
import PeoplePage from './modules/audience/people/PeoplePage';
import GroupsPage from './modules/audience/groups/GroupsPage';
import GroupPage from './modules/audience/groups/GroupPage';
import SettingsPage from './modules/admin/settings/SettingsPage';
import MessageResultsPage from './modules/messages/results/MessageResultsPage';
import { CircularProgress } from '@mui/material';
import DownloadsPage from './modules/admin/client-app/DownloadsPage';
import ForgotPasswordPage from './modules/login/ForgotPasswordPage';
import ResetPasswordPage from './modules/login/ResetPasswordPage';
import SignUpPage from './modules/signUp/signUpPage';

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      {user ? (
        <>
          <Header />
          <Sidebar />
          <div className="content">
            <Routes>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/audience" element={<AudiencePage />} />
              <Route path="/audience/recipients" element={<PeoplePage />} />
              <Route path="/audience/groups" element={<GroupsPage />} />
              <Route path="/audience/groups/:id" element={<GroupPage />} />
              <Route path="/admin/users" element={<UsersPage />} />
              <Route path="/admin/settings" element={<SettingsPage />} />
              <Route path="/admin/app-downloads" element={<DownloadsPage />} />
              <Route path="/create-message" element={<CreateMessagePage />} />
              <Route path="/edit-message/:id" element={<CreateMessagePage />} />
              <Route path="/message/:messageId/results" element={<MessageResultsPage />} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
          <Route path="*" element={<Navigate to="/login" state={{ from: location }} />} />
        </Routes>
      )}
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;